import File from './File';

type FileListProps = { files: FileObject[] }

function FileList(props: FileListProps) {
  return (
    <div className="FileList">
      {props.files.map((file) => <File key={file.name} file={file} />)}
    </div>
  );
}

export default FileList;
